'use strict';

exports.__esModule = true;

var _util = require('./util');

exports.default = function (_ref) {
  var _fn$propTypes;

  var key = _ref.key,
      _ref$prop = _ref.prop,
      prop = _ref$prop === undefined ? 'variant' : _ref$prop;

  var fn = function fn(props) {
    return (0, _util.get)(props.theme, key, props[prop]) || null;
  };
  fn.propTypes = (_fn$propTypes = {}, _fn$propTypes[prop] = _util.propTypes.numberOrString, _fn$propTypes);
  return fn;
};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/styled-system/dist/variant.js
// module id = 227
// module chunks = 6